var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"security-box"},[_c('dialog-video',{attrs:{"show":_vm.showTipView,"x":_vm.positionX,"y":_vm.positionY,"itemData":_vm.cameraIndexCode},on:{"showChange":function($event){_vm.showTipView = false}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }